import api from './api';

class AnalyticsService {
    constructor() {
        this.lastTracked = null;
    }

    async trackPageView(pageType, contentId = null, title = null, category = null) {
        // Prevent duplicate tracking for same page within 2 seconds
        const now = Date.now();
        if (this.lastTracked && (now - this.lastTracked) < 2000) return;
        this.lastTracked = now;

        try {
            const referrer = document.referrer || 'direct';
            const deviceType = this.getDeviceType();

            await api.post('/analytics/track', {
                pageType,
                contentId,
                title,
                category,
                referrer,
                deviceType,
                currentPage: window.location.pathname
            });
        } catch (error) {
            console.error('Analytics tracking error:', error);
        }
    }

    getDeviceType() {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) return 'tablet';
        if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) return 'mobile';
        return 'desktop';
    }

    async getActiveUsers() {
        try {
            const res = await api.get('/analytics/active-users');
            return res.data.activeUsers;
        } catch (error) {
            console.error('Error fetching active users:', error);
            return 0;
        }
    }
}

export default new AnalyticsService();